import { COURSE_INFO } from '@components/locale-pages/home/courses'
import ResponsiveCourseCard from './responsive-course-card'
import { FastlyImage } from '@components/common/image'
import Modal from '@components/common/modal'
import { useState } from 'react'

type Props = {
  courseCodes: string[]
  title?: string
  description?: JSX.Element
  showAICourseVideo?: boolean
}

const RecommendedCourses = ({
  courseCodes,
  title,
  description,
  showAICourseVideo,
}: Props) => {
  const [ismodalOpen, setModalOpen] = useState(false)
  const [videoURL, setVideoURL] = useState('')

  const recommendedCourses = COURSE_INFO.filter((course) =>
    courseCodes.includes(course.courseCode)
  )

  return (
    <>
      <Modal
        isOpen={ismodalOpen}
        setIsOpen={setModalOpen}
        isCrossIconShown={true}
        shouldCloseOnEsc
        width="mt-12 sm:mt-5 lg:max-w-lg"
      >
        <video
          controlsList="nodownload"
          controls
          autoPlay
          className="-my-5 sm:-my-10 rounded-lg  mx-auto"
          style={{ height: '80vh' }}
        >
          <source src={videoURL} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </Modal>

      <div className="m-20 flex flex-col text-grey container mx-auto lg:px-3 py-5 lg:bg-blue-50 lg:bg-opacity-25">
        <h2 className="text-2xl md:text-2xl font-600 mb-4 leading-tight">
          {title ? title : <>More recommended courses for you</>}
        </h2>
        <div className="flex flex-wrap justify-around gap-4 mb-4">
          {recommendedCourses.map((recommendedCourse, index) => (
            <ResponsiveCourseCard key={index} course={recommendedCourse} />
          ))}
        </div>
        {showAICourseVideo && (
          <>
            <h3 className="text-lg font-600 text-center mb-3">
              Dive In! Watch Videos and Explore Our Curriculum in Action!
            </h3>
            <div className="flex justify-center mb-4 gap-4 flex-wrap">
              <div
                className="w-80 max-w-full shadow hover:shadow-lg border border-grey-400 rounded-md cursor-pointer bg-white"
                onClick={() => {
                  setModalOpen(true)
                  setVideoURL(
                    'https://codingal.s3.ap-south-1.amazonaws.com/web/videos/AI-Genius.mp4'
                  )
                }}
              >
                <FastlyImage
                  src="/images/courses/ai-genius-video-thumbnail.png"
                  webpSrc="/images/courses/ai-genius-video-thumbnail.webp"
                  alt="AI Genius course video thumbnail for kids"
                  className="w-full"
                  width={400}
                  height={400}
                />
                <p className="text-center text-grey-700 my-2 text-2xl font-600">
                  AI Genius
                </p>
              </div>
              <div
                className="w-80 max-w-full shadow hover:shadow-lg border border-grey-400 rounded-md cursor-pointer bg-white"
                onClick={() => {
                  setModalOpen(true)
                  setVideoURL(
                    'https://codingal.s3.ap-south-1.amazonaws.com/web/videos/AI-Expert1.mp4'
                  )
                }}
              >
                <FastlyImage
                  src="/images/courses/ai-expert-video-thumbnail.png"
                  webpSrc="/images/courses/ai-expert-video-thumbnail.webp"
                  alt="AI Expert course video thumbnail for kids & teens"
                  className="w-full"
                  width={400}
                  height={400}
                />
                <p className="text-center text-grey-700 my-2 text-2xl font-600">
                  AI Expert
                </p>
              </div>
            </div>
          </>
        )}
        {description && <p>{description}</p>}
      </div>
    </>
  )
}

export default RecommendedCourses
